import { ProviderEnum } from '@dynamic-labs/sdk-api-core';
import * as z from 'zod/mini';

import { createStorageKeySchema } from '../../../../../services/storage';

/** The schema to track the state of the OAuth flow. */
export const redirectStateStorageKeySchema = createStorageKeySchema({
  key: 'redirectState',
  schema: z.object({
    codeVerifier: z.optional(z.string()),
    provider: z.enum(ProviderEnum),
    state: z.string(),
  }),
});
